import { CreatePartnerDTO } from "@/domain/dto/CreatePartnerDTO";
import { UpdatePlanExpirationDateDTO } from "@/domain/dto/UpdatePlanExpirationDateDTO";
import { isDateFuture } from "@/utils/Validators";
import moment from "moment";

export class PartnerValidator {
    static validateCreate(params: CreatePartnerDTO) {
        //TODO: validar os campos
        return true
    }
}